export function deploymentCommitLabel(deploymentId: string): string {
  return deploymentId.split("-", 1)[0].slice(0, 7);
}
